import React from "react";
import BatchManagement from "../../convoke/screens/BatchManagement";

const ExecutionControlCenter = ({
  activeTab = "overview",
  screenKey = "/execution-control/command-center/overview/",
}) => (
  <BatchManagement
    experience="execution-control"
    hideTabs={true}
    initialActiveTab={activeTab}
    routeScreenKey={screenKey}
  />
);

export default ExecutionControlCenter;
